import "../../pages/recall-details.css";
import { convertInMonthNameFormat } from "../../utils/helper";
import PropTypes from "prop-types";
import { RenderRichText } from "./render-rich-text";
export const FoodComponent = ({
  item,
  showContainer = true,
  showRestData = true
}) => {
  const hasRichData = Boolean(item?.rich_text_enabled);
  return (
    <>
      {showContainer && (
        <div
          style={{
            backgroundColor: "#D5E4F0",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            marginTop: "10px"
          }}>
          <h3 className="recall-summary">{item?.recall_title}</h3>
          <div style={{ display: "flex", flexWrap: "nowrap" }}>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>{item?.id}</span>
                <span> Recall ID </span>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>{convertInMonthNameFormat(item?.report_date)}</span>
                <span>Recall Date</span>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>{item?.classification}</span>
                <span>Classification</span>
              </div>
            </div>
            {item?.status && (
              <div className="col-sm-2">
                <div className="recall-details-card-item">
                  <span>{item?.status}</span>
                  <span>Status</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {showRestData && (
        <>
          {item?.items_recalled && (
            <div className="recall-details-body-item">
              <h2>Items Recalled</h2>
              {hasRichData ? (
                <RenderRichText text={item.items_recalled} />
              ) : (
                <p>{item.items_recalled}</p>
              )}
            </div>
          )}
          {item?.affected_locations && (
            <div className="recall-details-body-item">
              <h2>Affected Locations</h2>
              {hasRichData ? (
                <RenderRichText text={item.affected_locations} />
              ) : (
                <p>{item.affected_locations}</p>
              )}
            </div>
          )}
          {item?.recalling_firm && (
            <div className="recall-details-body-item">
              <h2>Recalling Firm</h2>
              {hasRichData ? (
                <RenderRichText text={item.recalling_firm} />
              ) : (
                <p>{item.recalling_firm}</p>
              )}
            </div>
          )}
          {item?.product_description && (
            <div className="recall-details-body-item">
              <h2>Product Description</h2>
              {hasRichData ? (
                <RenderRichText text={item.product_description} />
              ) : (
                <p>{item.product_description}</p>
              )}
            </div>
          )}
          {item?.reason_for_recall && (
            <div className="recall-details-body-item">
              <h2>Reason For Recall</h2>
              <p>{item.reason_for_recall}</p>
            </div>
          )}
          {item?.product_quantity && (
            <div className="recall-details-body-item">
              <h2>Product Quantity</h2>
              <p>{item.product_quantity}</p>
            </div>
          )}
          {item?.code_info && (
            <div className="recall-details-body-item">
              <h2>Code Info</h2>
              <p>{item.code_info}</p>
            </div>
          )}
          {item?.distribution_pattern && (
            <div className="recall-details-body-item">
              <h2>Distribution Pattern</h2>
              <p>{item.distribution_pattern}</p>
            </div>
          )}
          {item?.initial_firm_notification && (
            <div className="recall-details-body-item">
              <h2>Initial Firm Notification</h2>
              <p>{item.initial_firm_notification}</p>
            </div>
          )}
          {item?.consequences && (
            <div className="recall-details-body-item">
              <h2>Consequences</h2>
              {hasRichData ? (
                <RenderRichText text={item.consequences} />
              ) : (
                <p>{item.consequences}</p>
              )}
            </div>
          )}
          {item?.remedy && (
            <div className="recall-details-body-item">
              <h2>Remedy</h2>
              {hasRichData ? (
                <RenderRichText text={item.remedy} />
              ) : (
                <p>{item.remedy}</p>
              )}
            </div>
          )}
          {item?.summary && (
            <div className="recall-details-body-item">
              <h2>Summary</h2>
              {hasRichData ? (
                <RenderRichText text={item.summary} />
              ) : (
                <p>{item.summary}</p>
              )}
            </div>
          )}
          {item?.source && (
            <div className="recall-details-body-item">
              <h2>Source</h2>
              {hasRichData ? (
                <RenderRichText text={item.source} />
              ) : (
                <p>{item.source}</p>
              )}
            </div>
          )}
          {item?.web_source && (
            <div className="recall-details-body-item">
              <h2>Web Source</h2>
              <p>{item.web_source}</p>
            </div>
          )}
          {item?.compnay_CInfo && (
            <div className="recall-details-body-item">
              <h2>Company Contact Info</h2>
              <p>{item.compnay_CInfo}</p>
            </div>
          )}
          {item?.FSISCInfo && (
            <div className="recall-details-body-item">
              <h2>FSIS Contact Info</h2>
              <p>{item.FSISCInfo}</p>
            </div>
          )}
          {item?.FSISEstID && (
            <div className="recall-details-body-item">
              <h2>FSIS Establishment ID</h2>
              <p>{item.FSISEstID}</p>
            </div>
          )}
          {item?.ImageLink && (
            <div className="recall-details-body-item">
              <h2>Image Link</h2>
              <p>{item.ImageLink}</p>
            </div>
          )}
          {item?.URL && (
            <div className="recall-details-body-item">
              <h2>URL</h2>
              <p>{item.URL}</p>
            </div>
          )}
          {item?.Publisher && (
            <div className="recall-details-body-item">
              <h2>Publisher</h2>
              <p>{item.Publisher}</p>
            </div>
          )}
          {item?.FSNtags && (
            <div className="recall-details-body-item">
              <h2>FSN Tags</h2>
              <p>{item.FSNtags}</p>
            </div>
          )}
          {item?.lot_no && (
            <div className="recall-details-body-item">
              <h2>Lot Number</h2>
              <p>{item.lot_no}</p>
            </div>
          )}
          {item?.termination_date && (
            <div className="recall-details-body-item">
              <h2>Termination Date</h2>
              <p>{item.termination_date}</p>
            </div>
          )}
          {item?.more_code_info && (
            <div className="recall-details-body-item">
              <h2>More Code Info</h2>
              <p>{item.more_code_info}</p>
            </div>
          )}
          {item?.link && (
            <div className="recall-details-body-item">
              <h2>Link</h2>
              <p>
                <a href={item.link} target="_blank" rel="noreferrer">
                  {item.link}
                </a>
              </p>
            </div>
          )}
        </>
      )}
    </>
  );
};
FoodComponent.propTypes = {
  item: PropTypes.object.isRequired,
  showContainer: PropTypes.bool,
  showRestData: PropTypes.bool
};
